import { GraphTemplateV2 } from "app/components/widget/dashboard/GraphTemplate-v2";
import * as _ from "lodash";
import { dashboardMmxTooltipPositioner, tooltipPositioner } from "app/services/HighchartsPositioner";
import { MmxDashboardWidgetFilters } from "../widget-filters/MmxDashboardWidgetFilters";
import { MmxChannelsGraphDashboardWidget } from "./MmxChannelsGraphDashboardWidget";

/**
 * Created by Eyal.Albilia
 */
export class MmxPagesPerVisitDashboardWidget extends MmxChannelsGraphDashboardWidget {
    static getWidgetMetadataType() {
        return "MmxPagesPerVisitDashboard";
    }

    static getWidgetResourceType() {
        return "Graph";
    }

    static getWidgetDashboardType() {
        return "Graph";
    }

    protected getToolTipFormatSettings(dataMode): any {
        return {
            tooltipFormat: "number",
            formatParams: [2],
        };
    }

    get templateUrl() {
        return `/app/components/widget/widget-templates/graph.html`;
    }

    get templateComponent() {
        return GraphTemplateV2;
    }

    getHighChartsConfig(chartOptions, formattedData) {
        _.merge(chartOptions, this.getToolTipFormatSettings(null));
        return this._highchartsConfig.lineGraphWidget(
            _.merge({}, chartOptions, {
                stacked: false,
                xAxis: {
                    labels: {
                        y: 30,
                    },
                },
                tooltip: {
                    positioner: this.isCompare() ? tooltipPositioner : dashboardMmxTooltipPositioner,
                },
            }),
            formattedData,
        );
    }

    static getFiltersComponent() {
        return MmxDashboardWidgetFilters;
    }

    _getProUrlParams() {
        const channelAnalysisMetric = "PagesPerVisit";
        return Object.assign(super._getProUrlParams(), {
            channelAnalysisMetric,
        });
    }
}

MmxPagesPerVisitDashboardWidget.register();
